import { Injectable } from '@angular/core';
import { AllEvents } from '@core/models/all-events.model';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';

@Injectable()
export class AllEventsEntityService extends EntityCollectionServiceBase<AllEvents> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('AllEvents', serviceElementsFactory);
    }
}